import { WinFormsContentScreen } from '@winforms';
import { __asyncI18n } from '@localisation';
import { RoutingEntry } from '@routing';
import { UserEditComponent, UserListComponent } from '@user';

export const UserRoutes: Array<RoutingEntry> = [
     {
        path : '',
        component: UserListComponent,
        data: {
            title: __asyncI18n('Users', 'subnavi.administration.user'),
        //    contentRoute : '/SystemAdministration/User/List',
            showSubNaviLevel: 1,
            favouritesType: 'users'
        }
    },
    {
        path : 'Settings',
        data : {
           title : __asyncI18n('Settings', 'subnavi.administration.user.settings'),
           showSubNaviLevel: 1,
           dontShowInBreadCrumb : true,
           caption: __asyncI18n('Create new admin', 'subnavi.administration.user.settings.alternate.title')
        },
        children : [
            {
                path : '',
                component: UserEditComponent,
                data : {
                    title : __asyncI18n('Settings', 'subnavi.administration.user.settings'),
                    showSubNaviLevel: 1,
                }
            },
            {
                path : ':username',
                component: WinFormsContentScreen,
                data : {
                    title : ':username | userIdFromQueryToName',
                    showSubNaviLevel: 1,
                    favouritesCaption: '[UserName]',
                    contentRoute : '/SystemAdministration/User/Settings/:username',
                    contentRouteParams : {
                        tenantid : ':tenantId'
                    }
                }
            }
        ]
    },
    {
        path : ':userid',
        data : {
            title : ':userid | userIdFromQueryToName',
           // redirectTo : '/Administration/User',
            showSubNaviLevel: 1,
            dontShowInSubNavigation: true,
            favouritesRouteCaption: '[UserName]'
        },
        children : [
            {
                path : '',
                component : UserEditComponent,
                data : {
                    title : ':userid | userIdFromQueryToName',
                    showSubNaviLevel: 1,
                    dontShowInSubNavigation: true
                   // title : ':userid | userIdFromQueryToName',
                 //   redirectTo : '/Administration/User',
                }
            }
        ]
    }
];
